import * as angular from "angular";

export class NotFoundController {
  public static $inject: any[] = [];

  constructor() {}
}

angular
  .module("PortalApp")
  .controller("Rhinestone.NotFoundController", NotFoundController);
